import React from "react";
import "./advertise.css";
import { NavLink } from 'react-router-dom';

function Advertise(props) {
  return (
    <div className="containers">
      <div className="home_page my-2">
        <h3>
          Home <i class="bi bi-chevron-right"></i>
        </h3>
        <p>Advertise</p>
      </div>
      <div className="advertise">
        <h1>Advertise</h1>
        <p>
          Tahlil24.uz the internet edition sets out its own goals. If possible,
          it is necessary to bring statistical data (to convey to the client why
          he should advertise in this publication exactly).
        </p>
        <h4 className="py-4">Price for advertising</h4>
        <a href="/" className="download__price" download="">
          <svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 24 24"
            class="download__icon"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
            className="me-2"
          >
            <g>
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M3 19h18v2H3v-2zM13 9h7l-8 8-8-8h7V1h2v8z"></path>
            </g>
          </svg>
          Tahlil24.uzda reklama.pdf
        </a>
        <h4 className="pt-4">
          Contact for advertising and additional questions:  <NavLink to="/" className="info_adverts">info@tahlil24.uz</NavLink>
        </h4>
        <h4 className="mb-4">
        Communication via Telegram: <a href="/" className="info_adverts">info@tahlil24.uz</a>  
        </h4>
      </div>
    </div>
  );
}

export default Advertise;
